import React from "react";
import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import MasterStaffChangePasswordComponent from "../components/auth/profile/MasterStaffChangePasswordComponent";

const MasterStaffUpdatePasswordPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Update Password"
        routes={[{ title: "Home", path: "/" }]}
      />
      <MasterStaffChangePasswordComponent />
    </>
  );
};
export default MasterStaffUpdatePasswordPage;
